import '../../App.css';
import { Chrono } from "react-chrono";
import Navbar from '../Navbar';
import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore'
import { db } from '../../lib/init-firebase'


export default function Journey() {

  const [journeys, setJourneys] = useState([])

  useEffect(() => {
    getJourneys()
  }, [])

  useEffect(() => { 
    console.log(journeys)
  }, [journeys])

  function getJourneys() {

    const journeysQuery = query(collection(db, 'journey'),  orderBy("index", "asc"))
    
    getDocs(journeysQuery).then(response => {
      const journeys = response.docs.map(doc => ({
        data: doc.data(), 
        id: doc.id,
      }))

      setJourneys(journeys.map(obj => obj.data))
    }).catch(error => console.log(error.message))
  }

  return (
    <>
      <Navbar />
      <div className='journey'>
      <div style={{ width: '100%', height: '90%', margin:'0 auto' }}>
      {journeys.length > 0 && <Chrono items={journeys} mode="VERTICAL_ALTERNATING" theme={{
    titleColor: 'white',
  }}/>}
      </div>
    </div>
    </>
  )
}
